import React from 'react';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';

import { api, getToken, setToken, setClaims, getClaims } from '../api';

const Context = React.createContext({});

class ContextProviderImpl extends React.PureComponent {
  state = {
    token: null,
    claims: null,
    loading: true
  };

  error = message => {
    return toast.error(message);
  };

  componentDidMount() {
    this.setState({ token: getToken(), loading: false });

    api.interceptors.response.use(
      res => res,
      error => {
        if (
          (!axios.isCancel(error) && !error.response) ||
          (error.response && error.response.status === 401)
        ) {
          this.logout();
        }

        return Promise.reject(error);
      }
    );
  }

  login = values => {
    this.setState({ loading: true });
    api
      .post('/auth', {
        Name: values.Name,
        Password: values.Password
      })
      .then(res => res.data)
      .then(response => {
        if (response.Status !== 200) {
          this.error(response.Errors[0]);
          this.setState({ loading: false });
        } else {
          this.setState({ loading: false });

          this.setState(
            {
              token: setToken(response.Token),
              claims: setClaims(response.Claims)
            },
            () => this.props.history.push('/')
          );
        }
      })
      .catch(function(error) {
        this.error('503 error');
      });
  };

  logout = () => {
    this.setState({ token: setToken() }, () =>
      this.props.history.push('/login')
    );
  };

  render() {
    const { loading, token } = this.state;
    return (
      <Context.Provider
        value={{
          token,
          loading,
          login: this.login,
          logout: this.logout
        }}
      >
        {this.props.children}
      </Context.Provider>
    );
  }
}

export const ContextProvider = withRouter(ContextProviderImpl);

export const ContextConsumer = Context.Consumer;
